// extracted by mini-css-extract-plugin
export var alignBaseline = "_1b-9";
export var alignCenter = "_1b-5";
export var alignFlexEnd = "_1b-7";
export var alignFlexStart = "_1b-6";
export var alignSelfBaseline = "_1b-e";
export var alignSelfCenter = "_1b-a";
export var alignSelfFlexEnd = "_1b-c";
export var alignSelfFlexStart = "_1b-b";
export var alignSelfStretch = "_1b-d";
export var alignStretch = "_1b-8";
export var column = "_1b-2";
export var columnReverse = "_1b-4";
export var flex = "_1b-0";
export var justifyCenter = "_1b-f";
export var justifyFlexEnd = "_1b-h";
export var justifyFlexStart = "_1b-g";
export var justifySpaceAround = "_1b-j";
export var justifySpaceBetween = "_1b-i";
export var justifySpaceEvenly = "_1b-k";
export var row = "_1b-1";
export var rowReverse = "_1b-3";
export var wrapNowrap = "_1b-m";
export var wrapWrap = "_1b-l";
export var wrapWrapReverse = "_1b-n";